import { api } from '../../../api/client';

/**
 * Opens the Purchase Order report in a new browser tab, for the Ordering Items
 * "Reports" button (G5 FormReportPermissionViewController.ShowPdfInNewTab).
 * Receiving Items' "POReport" link is a different G5 action that downloads, so it
 * keeps its own code.
 *
 * @returns false when the browser blocked the tab, so the caller can say so.
 */
export async function openPoReportInNewTab(poId: string): Promise<boolean> {
  const res = await api.get(`/api/v1/receive-items/${poId}/po-report`, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([res.data as BlobPart], { type: 'application/pdf' }));
  const tab = window.open(url, '_blank');
  // Long enough for the tab to load the PDF; same allowance as FormReportsMenu.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return tab !== null;
}

/** The warning for a blocked tab, shared so both Ordering Items screens say the same. */
export const PO_REPORT_TAB_BLOCKED =
  'The browser blocked the report tab. Allow pop-ups for this site and try again.';
